import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { selectAllCriteria } from './search-criteria-read.adapter';

const selectSelf = (state: RootState) => state;
const getSearchCriteriaState = createSelector(selectSelf, (state) => state.searchCriteriaRead);

const getLoaded = createSelector(
  getSearchCriteriaState,
  (state) => state.loaded,
);

const getInManagement = createSelector(
  getSearchCriteriaState,
  (state) => state.inManagement,
);

const getEntities = createSelector(
  selectSelf,
  selectAllCriteria,
);

export const searchCriteriaReadQuery = {
  getLoaded,
  getInManagement,
  getEntities,
};
